/**
 * Created by vladislav on 29.04.20.
 */

// eslint-disable-next-line
let KeypadView = cc.Node.extend({
    avoidNode: "KeypadView",

    ctor: function (keypad) {
        this._super();

        this.keypad = keypad;

        const styles = cleverapps.styles.KeypadView;
        this.setAnchorPoint(0.5, 0.5);

        this.radius = styles.radius[this.keypad.letters.length] || styles.radius.default;

        this.createBackground();

        this.letters = this.keypad.letters.map((letter) => {
            const view = new KeypadLetterView(letter, this.radius);
            this.addChild(view);
            return view;
        });

        cleverapps.UI.wrap(this);

        this.addControls();
        this.addShuffleButton();

        this.setVisible(false);

        this.createEffects();

        this.setCascadeOpacityEnabledRecursively(true);

        this.onResize();

        this.addPathNode();

        keypad.on("push", this.onPush.bind(this), this);
        keypad.on("pop", this.onPop.bind(this), this);
        keypad.on("showUp", this.onShowUp.bind(this), this);
        keypad.on("controlTypeChanged", this.onChangeControlType.bind(this), this);
        keypad.on("hide", this.animateHide.bind(this), this);
        keypad.on("grabFocus", this.grabFocus.bind(this), this);
        keypad.on("shuffle", this.shuffle.bind(this), this);

        keypad.on("status", (status) => {
            this.pathNode.animateFadeOut(0.3);
            if (status === WordGame.STATUSES.SHORT) {
                this.pathNode.reset();
            }
        }, this);

        keypad.on("touchBegan", () => {
            this.shuffleButton.toggle(false);
        }, this);

        keypad.on("chooseLetter", this.createListener(this.chooseLetterAnimation.bind(this)), this);
        keypad.on("stopChooseLetter", this.createListener(this.stopChooseLetter.bind(this)), this);

        this.debugId = "Keypad";
    },

    shuffle: function () {
        const letterViews = this.keypad.letters.map((letter) => letter.onLocateView());

        cleverapps.UI.animateShuffle(letterViews);
    },

    onResize: function () {
        const styles = cleverapps.styles.KeypadView;

        this.setScale(styles.scale[cleverapps.resolution.mode]);

        this.letters.forEach((letter) => letter.onResize());

        const size = cleverapps.resolution.getSceneSize();
        const position = cc.p(size.width / 2, this.height * this.getScale() / 2 + styles.offset);
        this.setAlignment(position);

        const isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;
        this.cancelButton.setAlignment(isVertical ? styles.controls.cancel.xMobile : styles.controls.cancel.x, styles.controls.cancel.y);
        this.submitButton.setAlignment(isVertical ? styles.controls.submit.xMobile : styles.controls.submit.x, styles.controls.submit.y);

        if (this.pathNode) {
            this.pathNode.reset();
            this.keypad.indexes.forEach((letter) => {
                this.pathNode.push(letter.onLocateView().getPathPosition());
            });
        }

        if (this.background) {
            this.background.setAlignment(this.width / 2, this.height / 2);
            this.background.setScale((2 * this.radius + styles.bg.diameter) / this.background.width);
        }
    },

    addPathNode: function () {
        this.pathNode = new cleverapps.Path(cleverapps.styles.COLORS.PATH_COLOR);
        this.addChild(this.pathNode);
    },

    createEffects: function () {
        this.effects = [];
        let soundId = 0;
        while (bundles.game.urls[`nota_${soundId}`]) {
            this.effects.push(`board.nota.${soundId}`);
            soundId++;
        }
    },

    onPush: function (letter) {
        if (this.keypad.amountKeys() === 1) {
            this.pathNode.reset();
        }
        this.pathNode.push(letter.onLocateView().getPathPosition());

        cleverapps.effects.fire(this.effects[(this.keypad.indexes.length - 1) % this.effects.length]);
    },

    onPop: function (letter, silent) {
        this.pathNode.pop();

        if (this.keypad.amountKeys() === 0) {
            this.pathNode.reset();
        }

        if (!silent) {
            cleverapps.effects.fire(this.effects[this.keypad.indexes.length % this.effects.length]);
        }
    },

    animateHide: function (f) {
        this.runAction(new cc.Spawn(
            new cc.FadeOut(0.3),
            new cc.Sequence(
                cleverapps.effects.fireAction("board.keypad.hide"),
                new cc.ScaleTo(0.3, 0.5).easing(cc.easeBackIn()),
                new cc.CallFunc(f),
                new cc.RemoveSelf()
            )
        ));
    },

    onShowUp: function (f, silent) {
        if (this.isVisible() && !cleverapps.silentIntro) {
            f();
            return;
        }

        const callback = function () {
            cleverapps.UI.onDrag(this, {
                instantDrag: true,
                onDragStart: this.onTouchBegan.bind(this),
                onDragMoveNotThrottled: this.onTouchMoved.bind(this),
                onDragEnd: this.onTouchEnded.bind(this)
            });

            f();
        }.bind(this);

        if (cleverapps.gameModes.noKeypad) {
            callback();
            return;
        }

        if (silent) {
            this.setVisible(true);
            callback();
            return;
        }

        this.setOpacity(0);

        this.runAction(new cc.Spawn(
            new cc.FadeIn(0.3),
            new cc.Sequence(
                new cc.ScaleTo(0, 0.5),
                new cc.Show(),
                new cc.ScaleTo(0.3, this.getScale()).easing(cc.easeBackOut()),
                new cc.CallFunc(callback)
            )
        ));
    },

    calcLetterTouched: function (touch) {
        for (let i = 0; i < this.keypad.letters.length; i++) {
            if (!this.keypad.letters[i].onLocateView()) {
                const views = this.children.filter((child) => child instanceof KeypadLetterView);

                throw new Error(`No letter view keypad.stopListeners: ${this.stopListeners} letter.stopListener: ${views[i] ? views[i].stopListeners : "noView"
                } gameOutcome: ${this.keypad.game.outcome} viewsLength: ${views.length} modelsLength: ${this.keypad.letters.length}`);
            }

            if (this.keypad.letters[i].onLocateView().isTouched(touch)) {
                return this.keypad.letters[i];
            }
        }
    },

    addControls: function () {
        const styles = cleverapps.styles.KeypadView;

        this.cancelButton = new cleverapps.UI.Button({
            content: new cc.Sprite(bundles.game.frames.cancel_icon_png),
            onClicked: function () {
                this.keypad.cancel();
            }.bind(this),
            width: styles.controls.width,
            height: styles.controls.height
        });

        this.cancelButton.avoidNode = "KeypadView";

        this.submitButton = new cleverapps.UI.Button({
            content: new cc.Sprite(bundles.game.frames.submit_icon_png),
            onClicked: function () {
                this.keypad.submit();
            }.bind(this),
            width: styles.controls.width,
            height: styles.controls.height
        });

        this.submitButton.avoidNode = "KeypadView";

        const updateControlSize = function () {
            const styles = cleverapps.styles.KeypadView;
            let scale = 1;
            if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
                scale = styles.controls.mobileScale;
            }
            this.baseScale = scale;
            this.setScale(scale);
        };

        this.cancelButton.onResize = updateControlSize.bind(this.cancelButton);
        this.submitButton.onResize = updateControlSize.bind(this.submitButton);

        this.cancelButton.onResize();
        this.submitButton.onResize();

        this.cancelButton.setVisible(false);
        this.submitButton.setVisible(false);

        if (!cleverapps.gameModes.hideKeypadControls) {
            this.addChild(this.cancelButton);
            this.addChild(this.submitButton);
        }
    },

    createBackground: function () {
        const styles = cleverapps.styles.KeypadView;

        if (!styles.bg) {
            return;
        }

        const bg = this.background = new cc.Sprite(bundles.game.frames.keypad_bg_png);
        bg.setLocalZOrder(-10);
        this.addChild(bg);
    },

    onChangeControlType: function (controlType) {
        if (controlType === Keypad.CONTROL_TYPES.CLICK) {
            this.cancelButton.setVisible(true);
            this.submitButton.setVisible(true);
            this.cancelButton.setScale(0.5);
            this.cancelButton.runAction(new cc.ScaleTo(0.2, this.cancelButton.baseScale));
            this.submitButton.setScale(0.5);
            this.submitButton.runAction(new cc.ScaleTo(0.2, this.submitButton.baseScale));
        } else {
            this.cancelButton.setVisible(false);
            this.submitButton.setVisible(false);
        }

        if (!FingerView.isRunning(this.finger)) {
            this.shuffleButton.toggle(controlType === Keypad.CONTROL_TYPES.UNDEFINED);
        }
    },

    addShuffleButton: function () {
        this.shuffleButton = new ShuffleButton(this.keypad);
        this.addChild(this.shuffleButton);
    },

    onTouchBegan: function (touch) {
        this.beginPoint = touch.getLocation();

        return this.keypad.touchBegan(this.calcLetterTouched(touch));
    },

    onTouchMoved: function (touch) {
        const styles = cleverapps.styles.KeypadView;

        const endPoint = touch.getLocation();
        if (Math.abs(endPoint.x - this.beginPoint.x) + Math.abs(endPoint.y - this.beginPoint.y) > styles.moveEps) {
            this.keypad.swipe();
        }

        if (this.keypad.controlType === Keypad.CONTROL_TYPES.MOVE) {
            this.pathNode.draw(this.convertTouchToNodeSpace(touch));
        }

        const letter = this.calcLetterTouched(touch);
        if (letter) {
            this.keypad.letterTouched(letter);
        }
    },

    onTouchEnded: function () {
        this.pathNode.draw();
        this.keypad.touchEnded();
    },

    grabFocus: function () {
        cleverapps.focusManager.setEventNodes([this]);
    },

    stopChooseLetter: function () {
        this.letters.forEach((letter) => {
            letter.stopAllActions();
        });
    },

    chooseLetterAnimation: function () {
        this.shuffleButton.hide();

        const availableLetters = this.letters.filter((letter) => {
            const positionsForLetter = Game.currentGame.board.selectLettersPositions(letter.letter.symbol);

            if (!positionsForLetter.length) {
                letter.disable();
            }

            return positionsForLetter.length;
        });

        const letters = PseudoRandom.GET().shuffle(availableLetters.slice());

        letters.forEach((letter, index) => {
            letter.chooseLetterAnimation(index + 1);
        });

        this.grabFocus();
    }
});

KeypadView.UNDER_LETTER_LAYER = 0;
KeypadView.LETTER_LAYER = 1;

cleverapps.styles.KeypadView = {
    scale: [0.8, 0.9, 1],
    moveEps: 30,

    offset: 30,

    radius: {
        default: 215,
        "3": 160,
        "4": 170,
        "5": 185,
        "6": 200
    },

    controls: {
        width: 180,
        height: 120,

        mobileScale: 1.0,

        submit: {
            x: { align: "center", dx: 400 },
            xMobile: { align: "center", dx: 300 },
            y: { align: "bottom", dy: 70 }
        },

        cancel: {
            x: { align: "center", dx: -400 },
            xMobile: { align: "center", dx: -300 },
            y: { align: "bottom", dy: 70 }
        }
    },

    chooseLetter: {
        animation: {
            x: { align: "center" },
            y: { align: "center" }
        },

        finger: {
            x: { align: "center" },
            y: { align: "center" }
        }
    }
};
